<template>
  <a-select-opt-group :class="bem.b()" v-bind="props">
    <template v-for="item in Object.keys($slots)" :key="item" #[item]="data">
      <slot :name="item" v-bind="data || {}"></slot>
    </template>
  </a-select-opt-group>
</template>

<script setup lang="ts">
import { selectOptGroupProps } from './select'
// import { SelectOptGroup } from 'ant-design-vue'
import { createNamespace } from '@ll-plus/utils'

defineOptions({ name: 'LlSelectOptGroup' })

const props = defineProps(selectOptGroupProps)

const bem = createNamespace('select-opt-group')
</script>
